import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import { RiSendPlaneLine } from "react-icons/ri";
import { TiEdit } from "react-icons/ti";
import { IoTrashOutline } from "react-icons/io5";
import { BsThreeDots } from "react-icons/bs";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { HiOutlineArrowRight } from "react-icons/hi";
import { AiOutlineEye } from "react-icons/ai";

// Example items, to simulate fetching from another resources.

function Items({
  setOpenEditStore,
  setOpenAddStore,
  setOpenDeleteStore,
  currentItems,
  setSelectedId,
}) {
  return (
    <>
      {currentItems &&
        currentItems.map((item, key) => (
          <tr key={key} className="border-b-[1px] w-full">
            <td className="w-fit">
              <input
                name="check"
                type="checkbox"
                className="text-[#E4E7EC] border-[#E4E7EC] border-[1px] ml-5 w-fit"
              />
            </td>
            <td className="text-sm text-[#101828] font-semibold font-Poppins-Regular py-1 pl-8 ">
              {item.product.name}
            </td>
            <td className="text-sm text-[#101828] font-semibold font-Poppins-Regular py-1 pl-8 ">
              {item.quantity}
            </td>
            <td className="text-sm text-[#101828] font-semibold font-Poppins-Regular pr-5 py-1 ">
              <div className="flex space-x-2 ">
                <TiEdit
                  className="text-2xl  opacity-50 cursor-pointer"
                  onClick={() => {
                    setOpenEditStore(true);
                    setSelectedId(item.id);
                  }}
                />
                <IoTrashOutline
                  className="text-2xl text-[#F04438] cursor-pointer"
                  onClick={() => {
                    setOpenDeleteStore(true);
                    setSelectedId(item.id);
                  }}
                />
              </div>
            </td>
          </tr>
        ))}
    </>
  );
}

function StoreDBPangration({
  setOpenEditStore,
  setOpenAddStore,
  setOpenDeleteStore,
  setSelectedId,
  itemsPerPage,
  Data,
}) {
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  // Simulate fetching items from another resources.
  // (This could be items from props; or items loaded in a local state
  // from an API endpoint with useEffect and useState)
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = Data.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(Data.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % Data.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );

    setItemOffset(newOffset);
  };

  const Checkall = () => {
    if (document.getElementById("HeadCheck").checked) {
      let checks = document.getElementsByName("check");
      for (let i = 0; i <= checks.length; i++) {
        checks[i].checked = true;
      }
    } else if (!document.getElementById("HeadCheck").checked) {
      let checks = document.getElementsByName("check");
      for (let i = 0; i <= checks.length; i++) {
        checks[i].checked = false;
      }
    }
  };
  return (
    <div className={`overflow-x-scroll`}>
      <table className="w-full h-full mt-5 bg-white rounded-t-2xl ">
        <tr className="border-b-[1px] w-full">
          <td className="w-[5%]  pr-2 lg:pr-0">
            <input
              id="HeadCheck"
              type="checkbox"
              className="text-[#E4E7EC] border-[#E4E7EC] border-[1px] ml-5 "
              onClick={() => Checkall()}
            />
          </td>
            <td className="text-sm text-[#98A2B3] font-Poppins-Regular py-1 px-8 w-[85%]">
              Product
            </td>
            <td className="text-sm text-[#98A2B3] font-Poppins-Regular py-1 px-8 w-[85%]">
              Quantity
            </td>
            <td className="text-sm text-[#98A2B3]  font-Poppins-Regular py-1 pr-5 w-[15%]">
              Action
            </td>
          </tr>
        <Items
          setOpenEditStore={setOpenEditStore}
          setOpenAddStore={setOpenAddStore}
          setOpenDeleteStore={setOpenDeleteStore}
          currentItems={currentItems}
          className="w-full bg-white"
          setSelectedId={setSelectedId}
        />
      </table>

      <ReactPaginate
        breakLabel={<BsThreeDots />}
        nextLabel={
          <div className="bg-white py-[0.4rem] px-2  rounded-lg">
            <HiOutlineArrowRight className="bg-white text-xl" />
          </div>
        }
        onPageChange={handlePageClick}
        pageRangeDisplayed={1}
        pageCount={pageCount}
        previousLabel={
          <div className="bg-white py-[0.4rem] px-2  rounded-lg">
            <HiOutlineArrowLeft className="bg-white text-xl" />
          </div>
        }
        pageClassName="bg-white  font-Poppins-Regular py-1 px-3 rounded-lg"
        containerClassName="flex justify-center space-x-5 mb-2 border-gray-400 w-full  bottom-0   items-center mt-10"
        activeClassName="bg-[#B7C835] text-[#FFFFFF] "
        renderOnZeroPageCount={null}
      />
    </div>
  );
}
export default StoreDBPangration;